<template>
  <div>
    <b-row>
      <b-col>
        <welcome-card />
        <planning-card />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { BRow, BCol } from "bootstrap-vue";
import WelcomeCard from "@/views/home/components/WelcomeCard.vue";
import PlanningCard from "@/views/home/components/PlanningCard.vue";

export default {
  components: {
    BRow,
    BCol,
    WelcomeCard,
    PlanningCard,
  },
};
</script>
